export const createRefreshCoordinator = (refreshAccessToken) => {
  let activeRefresh = null;

  return () => {
    if (!activeRefresh) {
      activeRefresh = Promise.resolve()
        .then(refreshAccessToken)
        .finally(() => {
          activeRefresh = null;
        });
    }

    return activeRefresh;
  };
};
